export enum CardState {
  CRITICAL,
  IN_PROGRESS,
  VALID,
}

export enum ContractStatus {
  MissingParts = "missingParts",
  ToSend = "toSend",
  Completed = "completed",
  Pending = "Pending",
  DocToSend = "docToSend",
  ToComplete = "toComplete",
  ATTSIGNATURE = "ATTSIGNATURE",
  AENVOYER = "AENVOYER",
  ASIGNER = "ASIGNER",
  ENVOYER = "ENVOYER",
  SIGNE = "SIGNE",
}
